import React from "react";

const Achievements = () => {
  return (
    <section id="achievements" className="section">
      <div className="card">
        <h2>Achievements</h2>
        <p>🏆 Participated in AI Hackathon (Indian Sign Language)</p>
      </div>
    </section>
  );
};

export default Achievements;